var _kv = null;
var getKV = function () {
    if (!_kv) {
        _kv = localStorage.getItem('kv');
        if (!_kv) {
            _kv = '{}';
        }
    }
    return JSON.parse(_kv);
};
var updateKv = function (value) {
    _kv = JSON.stringify(value);
    localStorage.setItem('kv', _kv);
};
var get = function (message) {
    var kv = getKV();
    var result = {};
    var keys = message.data.data.keys;
    keys.forEach(function (key) {
        var data = kv[key];
        result[key] = {
            found: Boolean(data),
            value: data ? data.value : null,
        };
    });
    return result;
};
var set = function (message) {
    var kv = getKV();
    var items = message.data.data.items;
    var result = {};
    items.forEach(function (item) {
        kv[item.key] = item;
        result[item.key] = {
            found: true,
            value: item.value,
        };
    });
    updateKv(kv);
    return result;
};
var keyValueMiddleware = function (dispatch) { return function (next, done) { return function (message) {
    if (message.domain !== 'kv') {
        return next(message);
    }
    if (message.eventType === 'get') {
        var result = get(message);
        dispatch({
            purpose: 'response',
            request_id: message.data.request_id,
            event_type: 'get',
            response_data: result,
        });
        done();
    }
    else if (message.eventType === 'set') {
        var result = set(message);
        dispatch({
            purpose: 'response',
            request_id: message.data.request_id,
            event_type: 'set',
            response_data: result,
        });
        done();
    }
    else {
        throw "Invalid event type " + message.eventType + " for domain kv";
    }
}; }; };
export default keyValueMiddleware;
//# sourceMappingURL=keyValue.js.map